export const searchRequestFactory = ({
    name,
    translationName,
    icon,
    component,
    modalRoute,
    searchMethod,
    searchResult,
    filters = {},
    defaultFilters = []
}: SearchRequestFactoryParameters): SearchRequest => ({
    name,
    translationName,
    icon,
    component,
    modalRoute,
    searchMethod,
    searchResult,
    filters,
    count: 0,
    errors: [],
    data: [],
    isLoading: false,
    isFilterActive: false,
    defaultFilters,
    compileFilters(query: any) {
        return Object.entries(filters) // Merge request specific filters with global filters
            .filter(([key]) => {
                // Filter null values and empty arrays
                const queryValue = query[key];
                const isArrayAndNotEmpty = Array.isArray(queryValue) && queryValue.length > 0;
                const isNotArrayAndNotEmpty = !Array.isArray(queryValue) && queryValue !== null && queryValue !== "" && queryValue !== undefined;

                return isArrayAndNotEmpty || isNotArrayAndNotEmpty;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([key, value]: [string, any]) => {
                // Destruct path and comparison. If path is undefined, default to value which should be a string.
                const { path = value, comparison } = value;

                // We need to stringify value
                let queryValue = query[key];
                if (Array.isArray(queryValue)) {
                    queryValue = queryValue.map((item: number|string) => item.toString());
                } else {
                    queryValue = queryValue?.toString();
                }

                return {
                    path,
                    ...Array.isArray(query[key]) && { comparison: "in" },
                    ...comparison && { comparison },
                    value: queryValue,
                };
            }); // Build array of where statements
    }
});

export interface SearchRequest extends SearchRequestFactoryParameters{
    count: number;
    isLoading: boolean;
    errors: string[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[];
    isFilterActive: boolean;
    compileFilters: Function;
}

interface SearchRequestFactoryParameters {
    name: string;
    translationName: string;
    icon: Function | string;
    component: Function | string;
    modalRoute: string;
    searchMethod: string;
    searchResult: string;
    filters: { [key: string]: string | FilterObject };
    defaultFilters: [{ [key: string]: string }] | [];
}

export interface FilterObject {
    path: string;
    comparison: string;
}
